var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_8536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.14 12.9384C19.18 12.6384 19.2 12.3284 19.2 11.9984C19.2 11.6784 19.18 11.3584 19.13 11.0584L21.16 9.47844C21.34 9.33844 21.39 9.06844 21.28 8.86844L19.36 5.54844C19.24 5.32844 18.99 5.25844 18.77 5.32844L16.38 6.28844C15.88 5.90844 15.35 5.58844 14.76 5.34844L14.4 2.80844C14.36 2.56844 14.16 2.39844 13.92 2.39844H10.08C9.83999 2.39844 9.64999 2.56844 9.60999 2.80844L9.24999 5.34844C8.65999 5.58844 8.11999 5.91844 7.62999 6.28844L5.23999 5.32844C5.01999 5.24844 4.76999 5.32844 4.64999 5.54844L2.73999 8.86844C2.61999 9.07844 2.65999 9.33844 2.85999 9.47844L4.88999 11.0584C4.83999 11.3584 4.79999 11.6884 4.79999 11.9984C4.79999 12.3084 4.81999 12.6384 4.86999 12.9384L2.83999 14.5184C2.65999 14.6584 2.60999 14.9284 2.71999 15.1284L4.63999 18.4484C4.75999 18.6684 5.00999 18.7384 5.22999 18.6684L7.61999 17.7084C8.11999 18.0884 8.64999 18.4084 9.23999 18.6484L9.59999 21.1884C9.64999 21.4284 9.83999 21.5984 10.08 21.5984H13.92C14.16 21.5984 14.36 21.4284 14.39 21.1884L14.75 18.6484C15.34 18.4084 15.88 18.0884 16.37 17.7084L18.76 18.6684C18.98 18.7484 19.23 18.6684 19.35 18.4484L21.27 15.1284C21.39 14.9084 21.34 14.6584 21.15 14.5184L19.14 12.9384ZM12 15.5984C10.02 15.5984 8.39999 13.9784 8.39999 11.9984C8.39999 10.0184 10.02 8.39844 12 8.39844C13.98 8.39844 15.6 10.0184 15.6 11.9984C15.6 13.9784 13.98 15.5984 12 15.5984Z",
    fill: "#419485"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_8536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.d6ad3d3f8862353147152abb4c0fcd5d.svg";
export { ForwardRef as ReactComponent };